import { Component, OnInit, ViewChildren } from "@angular/core";
import { AuthService } from "../auth.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { LoginComponent } from "../login/login.component";


@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.css"],
  providers: [LoginComponent]
})
export class SignupComponent implements OnInit {
  model: any = { type: 'phone' };
  nextPage = false;
  encryptedData: string;
  userInfo: any;
  isLoading = false;
  btnDisable = false;
  countryCode = 1;
  phoneNumber: any;
  signupfirst: any;
  registerByMobile = true;
  registerByEmail: boolean;

  @ViewChildren("input") input;

  constructor(
    private signUpService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public socialLogin: LoginComponent
  ) {
    if (localStorage.getItem(environment.localStorageKey)) {
      this.encryptedData = localStorage.getItem(environment.localStorageKey);
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );

      if (this.userInfo.result.subscription_type == null) {
        this.router.navigate(["/subscription"]);
      } else {
        this.router.navigate([""]);
      }
    }
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
  ngAfterViewInit() {
    this.input.first.nativeElement.focus();
  }
  /**
   * This function is use for submit form
   * @param form
   */
  onSubmit(form) {
    if (form) {

      if (this.btnDisable && this.model.type) {
        this.spinner.show();
        this.isLoading = true;
        let model_data;
        if (this.model.type == 'phone') {
          if (this.phoneNumber) {
            model_data = {
              code: this.countryCode,
              email: '',
              type: this.model.type,
              mobile: this.phoneNumber.replace("+" + this.countryCode, ""),
              country_name: this.model.country_name
                ? this.model.country_name
                : "us",
            };
          } else {
            model_data = {
              code: this.countryCode,
              email: '',
              type: this.model.type,
              mobile: this.model.phone,
              country_name: this.model.country_name
                ? this.model.country_name
                : "us",
            };
          }
        }
        else if (this.model.type == 'email') {
          model_data = {
            code: '',
            mobile: '',
            email: this.model.email,
            type: this.model.type,
            country_name: ''
          };
        }


        this.signUpService.firstStep(model_data).subscribe(
          (res) => {
            if (res) {
              this.spinner.hide();
              this.isLoading = false;

              this.signUpService.UpdateArray(res.results);
              const encryptData = CryptoJS.AES.encrypt(
                JSON.stringify(res.results),
                environment.secretkey
              ).toString();
              localStorage.setItem("signup_first", encryptData);
              this.router.navigate(["/otp-verification"]);
            }
          },
          (err) => {
            if (err) {
              this.btnDisable = true;
              this.isLoading = false;
              this.spinner.hide();

              this.toastr.error(err.message, "OOPS!", {
                closeButton: true,
              });
            }

          }
        );
      }
    }
  }
  trimNumber(event, type) {

    if (event) {
      if (type === 'number') {

        this.model.phone = event.target.value.trim();
      }
      if (type === 'email') {
        this.model.email = event.target.value.replace(" ", "");


      }
    }

  }
  signupType(type: string) {
    if (type == 'phone') {
      this.model.phone = ''
      this.model.type = type;
      this.registerByMobile = true;
      this.registerByEmail = false;

    } else if (type == 'email') {
      this.model.email = ''
      this.btnDisable = true
      this.model.type = type;
      this.registerByEmail = true;
      this.registerByMobile = false;

    }
  }
  telInputObject(obj) {
    obj.setCountry("us");
  }

  getNumber(myNum) {
    this.phoneNumber = myNum;
  }
  /**
   * This function is trigger on country change
   */
  onCountryChange(event) {
    this.btnDisable = true;
    this.countryCode = event.dialCode;
    this.model.country_name = event.iso2;
  }

  hasError(event) {
    if (event) {
      this.btnDisable = true;
    } else {
      this.btnDisable = false;
    }
  }
  /**
   * This function is trigger on input change
   */
  onInputChange(event) {
    if (event.toString().length > 2) {
      this.btnDisable = true;
    } else {
      this.btnDisable = false;
    }
  }
 
}
